module.exports = __webpack_public_path__ + "img/1完美家庭套房.cac4393.jpg";